import React from 'react';
import PropTypes from 'prop-types';
import { useLikesAndComments, useLoader } from '../../../services/customHooks';
import withCSRF from '../../../commonComponents/withCSRF';
import TimelineContainer from '../../../commonComponents/timeline/TimelineContainer';
import TimelineItem from './timeline/TimelineItem';
import CommentsModal from './timeline/CommentsModal';

function Timeline({ _csrf, challengeId }) {
  const { data, setData, isLoading } = useLoader(
    `/challenges/timeline/${challengeId}`,
    'error_fetchTimeline',
    [],
  );

  const {
    commentsModal,
    showCommentsModal,
    hideCommentsModal,
    handleAddComment,
    handleAddLike,
  } = useLikesAndComments(setData, _csrf);

  return (
    <>
      {commentsModal.show && (
        <CommentsModal
          eventId={commentsModal.id}
          onClose={hideCommentsModal}
          onAddComment={handleAddComment}
        />
      )}
      <div className="m-portlet__body timeline-container">
        {isLoading ? (
          <div className="loading-indicator" />
        ) : (
          <TimelineContainer>
            {data.map((event, index) => (
              <TimelineItem
                key={event._id}
                side={index % 2 === 0 ? 'left' : 'right'}
                isFirst={index === 0}
                event={event}
                onAddLike={handleAddLike}
                onAddComment={showCommentsModal}
              />
            ))}
          </TimelineContainer>
        )}
      </div>
    </>
  );
}

Timeline.propTypes = {
  _csrf: PropTypes.string.isRequired,
  challengeId: PropTypes.string.isRequired,
};

export default withCSRF(Timeline);
